import React, { ReactElement } from 'react';
import FilteredLink from '../filtered-link/filtered-link.component';
import FlexContainer from '../flex-container/flex-container.component';
import ActionBlock from '../action-block/action-block.component';
import useStylesConnectorLinkBlock from './connector-link-block.styles';

const ConnectorLinkBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEmail,
    isConnected,
    isColumnView,
    link,
    onConnectClick,
  } = props;

  const { classes } = useStylesConnectorLinkBlock();

  return (
    <FlexContainer isColumn={isColumnView} className={classes.connectorLinkBlock}>
      <FlexContainer>
        <FilteredLink isEmail={isEmail} link={link}>
          {link}
        </FilteredLink>
      </FlexContainer>
      <ActionBlock
        isInline
        isColumnView={isColumnView}
        isSuccessful={isConnected}
        labelSuccess="Connected"
        labelError="Not Connected"
        labelButton="Connect"
        onButtonClick={onConnectClick}
      />
    </FlexContainer>
  );
});

export default ConnectorLinkBlock;
